export const DEFAULT_LANYARD = {
  frontText: '教育背景在背面',
  backText: '本科：中国石油大学\n硕士：无',
  icon: '/education.png',
  visible: true,
  horizontal: 50,
  vertical: 0,
};

export function getLanyardContent(value) {
  const content = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  return { ...DEFAULT_LANYARD, ...content };
}
